import { render, staticRenderFns } from "./segmentBasicTypes.vue?vue&type=template&id=b2d4bee2&"
import script from "./segmentBasicTypes.vue?vue&type=script&lang=js&"
export * from "./segmentBasicTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports